import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template11.css";
import "./CheckoutTemplate11.css";

/*
   Checkout Template 11 — a seamless continuation of sales Template 11 ("Clarity").
   Reuses Template11.css directly (same .clp11-root design system): the real
   .cl11-nav, the light .cl11-hero with its glow + .cl11-title/.cl11-sub, the
   .cl11-btn.cl11-btn-p button and .cl11-foot footer. Only the form + order
   summary cards are checkout-specific (CheckoutTemplate11.css), styled to match
   the template's white app-window / feature-card look.
*/
export default function ThankYouTemplate11({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp11-root">
      {/* NAV — same as the sales page */}
      <nav className="cl11-nav scr">
        <div className="cl11-wrap cl11-nav-in">
          <span className="cl11-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok11-brandtext">{c.brand}</span>}
          </span>
          <span className="cok11-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + accent-word title */}
      <header className="cl11-hero cok11-hero">
        <div className="cl11-hero-glow" aria-hidden="true" />
        <div className="cl11-wrap">
          <div className="cok11-hero-content">
            <span className="cok11-eyebrow">Thank you</span>
            <h1 className="cl11-title">
              You're <span className="cok11-accent">enrolled</span>
            </h1>
            {c.sub ? <p className="cl11-sub cok11-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's card style */}
      <div className="cl11-wrap">
        <ThankYouBody data={data} p="cok11" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="cl11-foot">
        <div className="cl11-wrap cl11-foot-in">
          <div className="cok11-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
